export const poisBountyAssets = {
	page: {
		background: "/spec_pois_bounty/bg-page-pois-bounty.jpg",
		backgroundMobile: "/spec_pois_bounty/bg-page-mobile-pois-bounty.jpg"
	},
	v2: {
		page: {
			defaultBackground: "/spec_pois_bounty/v2/default-background-image.png",
			defaultBackgroundMobile:
				"/spec_pois_bounty/v2/default-background-image-mobile.png"
		},
		megaMenu: {
			background: "/spec_pois_bounty/v2/bg-pois-megamenu.png"
		},
		ftue: {
			background: "/spec_pois_bounty/v2/bg-page-pois-bounty-ftue-v2.png",
			logo: "/spec_pois_bounty/v2/pois-logo.png",
			loyalty: {
				first: "/spec_pois_bounty/v2/loyalty_FTUE.png",
				second: "/spec_pois_bounty/v2/loyalty_FTUE_2.png",
				third: "/spec_pois_bounty/v2/loyalty_FTUE_3.png"
			}
		},
		toShop: {
			eventCompleted: "/spec_pois_bounty/v2/poi-event-completed.png"
		},
		stickyTag: {
			background: "/spec_pois_bounty/v2/sticky-tag/sticky-background-pois.png",
			backgroundLandscape:
				"/spec_pois_bounty/v2/sticky-tag/sticky-background-pois-landscape.png"
		}
	},
	v3: {
		ftue: {
			background: "/spec_pois_bounty/v3/select-event-popup-landscape.jpg",
			logo: "/spec_pois_bounty/v3/pois-logo.png"
		},
		rewardCollected: {
			background: "/spec_pois_bounty/v3/claim-single-reward.png",
			shine: "/spec_pois_bounty/v3/bg-shine.png"
		},
		rewardsCollected: {
			background: "/spec_pois_bounty/v3/multiple-items-or-change-tier.png"
		},
		cycle: {
			background: "/spec_pois_bounty/v3/select-event-popup.jpg",
			backgroundLandscape:
				"/spec_pois_bounty/v3/select-event-popup-landscape.jpg"
		},
		eventEnded: {
			treasureChest: "/spec_pois_bounty/v3/pois_bounty_treasure_chest.png"
		},
		stickyTag: {
			background: "/spec_pois_bounty/v3/sticky-background-pois.png",
			backgroundLandscape:
				"/spec_pois_bounty/v3/sticky-background-pois-landscape.png"
		}
	},
	popups: {
		learnMore: {
			background: "/spec_pois_bounty/bg-pop-up.jpg"
		}
	},
	progress: {
		itemGlow: "/spec_pois_bounty/item-glow.png",
		lock: "/spec_pois_bounty/pois_bounty_lock.png",
		check: "/spec_pois_bounty/pois_bounty_icon_check.png",
		rewardBackground: "/spec_pois_bounty/pois_bounty_reward_background.png"
	},
	tutorial: {
		panelOne: "/spec_pois_bounty/Pois_bounty_tutorial_panel_1_desktop.png",
		panelTwo: "/spec_pois_bounty/Pois_bounty_tutorial_panel2_desktop.png",
		panelThree: "/spec_pois_bounty/Pois_bounty_tutorial_panel3_desktop.png"
	}
} as const;
